import React from "react";
import customPaperStyles from "./CustomPaper.styles";
import clsx from "clsx";
import { Paper } from "@material-ui/core";

interface CustomProps {
  children: React.ReactNode;
  className?: string;
  isWeb?: boolean;
  removeBorder?: boolean;
  isDisable?: boolean;
}

const CustomPaper = (props: CustomProps) => {
  const classes = customPaperStyles();
  if (props.removeBorder) {
    if (!props.isWeb) {
      return (
        <Paper
          variant="outlined"
          className={clsx(classes.customPaperMobile, props.className, {
            [classes.disable]: props.isDisable,
          })}
        >
          {props.children}
        </Paper>
      );
    }
  }
  return (
    <Paper
      variant="outlined"
      className={clsx(classes.customPaper, props.className, {
        [classes.disable]: props.isDisable,
      })}
    >
      {props.children}
    </Paper>
  );
};

export default CustomPaper;
